export const STORAGE_KEYS = {
  TOKEN: "bidi_bp_token",
  LANGUAGE: "bidi_bp_lang",
} as const;

export const POLLING_INTERVALS = {
  ACTIVE_ORDERS: 10_000,
  DASHBOARD: 30_000,
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
} as const;

export const FILE_UPLOAD = {
  MAX_SIZE_BYTES: 20 * 1024 * 1024,
  ACCEPTED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/webp", "image/gif"],
} as const;

export const RTL_LANGUAGES = ["he"] as const;
export const SUPPORTED_LANGUAGES = ["he", "en"] as const;
export const DEFAULT_LANGUAGE = "he" as const;

export const PLATFORM_HEADER = "BusinessPanel" as const;
